import { render, staticRenderFns } from "./documentDialog.vue?vue&type=template&id=e8c1518c&scoped=true"
import script from "./documentDialog.vue?vue&type=script&lang=js"
export * from "./documentDialog.vue?vue&type=script&lang=js"
import style0 from "./documentDialog.vue?vue&type=style&index=0&id=e8c1518c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1518c",
  null
  
)

export default component.exports